<div id="modal-gallery-wrapper"
     [attr.aria-label]="accessibilityConfig.modalGalleryContentAriaLabel"
     [title]="accessibilityConfig.modalGalleryContentTitle"
     ksClickOutside [clickOutsideEnable]="enableCloseOutside"
     (clickOutside)="onClickOutside($event)">

  <div id="flex-min-height-ie-fix">
    <div id="modal-gallery-container">

      <ks-upper-buttons [id]="id"
                        [currentImage]="currentImage"
                        (delete)="onDelete($event)"
                        (navigate)="onNavigate($event)"
                        (download)="onDownload($event)"
                        (closeButton)="onCloseGalleryButton($event)"
                        (fullscreen)="onFullScreen($event)"
                        (customEmit)="onCustomEmit($event)"></ks-upper-buttons>

      <ks-current-image [id]="id"
                        [images]="images"
                        [currentImage]="currentImage"
                        [isOpen]="true"
                        (loadImage)="onImageLoad($event)"
                        (changeImage)="onChangeCurrentImage($event)"
                        (closeGallery)="onCloseGallery($event)"></ks-current-image>

      <div>
        <ks-dots [id]="id"
                 [images]="images"
                 [currentImage]="currentImage"
                 [dotsConfig]="dotsConfig"
                 (clickDot)="onClickDot($event)"></ks-dots>

        <ks-previews [id]="id"
                     [images]="images"
                     [currentImage]="currentImage"
                     [customTemplate]="customPreviewsTemplate"
                     (clickPreview)="onClickPreview($event)"></ks-previews>
      </div>
    </div>
  </div>
</div>
